import * as React from 'react';
export const nyceSvg = React.forwardRef(function nyceSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.191 10c-.832 0-1.668-.915-1.355-2.043.256-.926.606-1.708 1.682-1.957h1.381c.643.207.914.781.84 1.5h-1.1c.003-.387-.17-.659-.552-.659-.529 0-.896.5-1.067 1.117-.171.616.03 1.116.449 1.116.538 0 .788-.27.95-.66h1.102c-.281.909-.69 1.586-2.33 1.586ZM3.47 6l-.55 2.092L2.135 6H.987L0 9.802h1.208L1.73 7.72l.735 2.08H3.64L4.66 6H3.47Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.689 6H7.304l-.922 1.288L6.012 6H4.694l.846 2.404-.352 1.398h1.264l.365-1.406L8.69 6ZM14.7 7.5l-.216.833h-1.579l-.17.653h1.808l-.212.816h-2.99L12.329 6h3.016l-.246.946h-1.833l-.144.555h1.58Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.626 6.427h.062l.093.148h.06l-.1-.15c.051-.006.091-.033.091-.094 0-.068-.041-.097-.125-.097h-.134v.34h.053v-.147Zm0-.044v-.106h.073c.037 0 .077.008.077.05 0 .053-.04.056-.086.056h-.064Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.69 6.7a.3.3 0 0 0 .31-.296c0-.17-.142-.295-.31-.295s-.31.125-.31.295c0 .17.142.295.31.295Zm-.25-.296c0-.14.11-.246.25-.246s.248.105.248.246a.242.242 0 0 1-.247.247.243.243 0 0 1-.25-.247Z',
    }),
  );
});
nyceSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var nyce = {
  category: 'paymentmethod',
  colorable: true,
  name: 'nyce',
  svg: nyceSvg,
};
